var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_7481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7174 11.0134C8.7174 11.4674 8.3687 11.8424 7.895 11.8424C7.43446 11.8424 7.06603 11.4739 7.06603 11.0134C7.06603 10.5463 7.43446 10.191 7.895 10.191C8.36213 10.191 8.7174 10.5529 8.7174 11.0134ZM7.88843 3.94738C6.72391 3.94738 5.92783 4.70399 5.63177 5.5856L6.71075 6.03956C6.8555 5.59875 7.19761 5.06584 7.895 5.06584C8.96083 5.06584 9.17136 6.06587 8.79635 6.59879C8.44108 7.10538 7.82921 7.4475 7.50683 8.01989C7.25025 8.47385 7.30288 9.00018 7.30288 9.32256H8.50029C8.50029 8.7107 8.54634 8.5857 8.64503 8.3949C8.90162 7.9212 9.37532 7.69751 9.87533 6.96722C10.3227 6.3093 10.1517 5.41454 9.86218 4.94084C9.52664 4.38819 8.86214 3.94738 7.88843 3.94738ZM12.5004 3.28947H3.28959V12.5003H12.5004V3.28947ZM12.5004 1.97363C13.2241 1.97363 13.8163 2.56576 13.8163 3.28947V12.5003C13.8163 13.224 13.2241 13.8161 12.5004 13.8161H3.28959C2.56588 13.8161 1.97375 13.224 1.97375 12.5003V3.28947C1.97375 2.56576 2.56588 1.97363 3.28959 1.97363H12.5004Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_7481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.79,
    height: 15.79,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.b8017a6d8836ec4cbe0c3b52df3ae751.svg";
export { ForwardRef as ReactComponent };